/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceAndConnectorStatus
 */
export interface DeviceAndConnectorStatus {
    /**
     *
     * @type {number}
     * @memberof DeviceAndConnectorStatus
     */
    statusItemId?: number;
    /**
     *
     * @type {boolean}
     * @memberof DeviceAndConnectorStatus
     */
    isDeviceOnlineStatus?: boolean;
    /**
     *
     * @type {string}
     * @memberof DeviceAndConnectorStatus
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceAndConnectorStatus
     */
    connectorIndex?: number;
    /**
     *
     * @type {Date}
     * @memberof DeviceAndConnectorStatus
     */
    timestamp?: Date;
    /**
     *
     * @type {string}
     * @memberof DeviceAndConnectorStatus
     */
    status?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceAndConnectorStatus
     */
    reason?: string;
}

/**
 * Check if a given object implements the DeviceAndConnectorStatus interface.
 */
export function instanceOfDeviceAndConnectorStatus(
    value: object,
): value is DeviceAndConnectorStatus {
    return true;
}

export function DeviceAndConnectorStatusFromJSON(
    json: any,
): DeviceAndConnectorStatus {
    return DeviceAndConnectorStatusFromJSONTyped(json, false);
}

export function DeviceAndConnectorStatusFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceAndConnectorStatus {
    if (json == null) {
        return json;
    }
    return {
        statusItemId:
            json["statusItemId"] == null ? undefined : json["statusItemId"],
        isDeviceOnlineStatus:
            json["isDeviceOnlineStatus"] == null
                ? undefined
                : json["isDeviceOnlineStatus"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        status: json["status"] == null ? undefined : json["status"],
        reason: json["reason"] == null ? undefined : json["reason"],
    };
}

export function DeviceAndConnectorStatusToJSON(
    value?: DeviceAndConnectorStatus | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        statusItemId: value["statusItemId"],
        isDeviceOnlineStatus: value["isDeviceOnlineStatus"],
        deviceIdentity: value["deviceIdentity"],
        connectorIndex: value["connectorIndex"],
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        status: value["status"],
        reason: value["reason"],
    };
}
